export const SET_INVOICE_ID = 'SET_INVOICE_ID';
export const SET_USER_PERMISSIONS_TASKS = 'SET_USER_PERMISSIONS_TASKS';
export const SET_USER_PERMISSIONS_REPORTS = 'SET_USER_PERMISSIONS_REPORTS';
export const SET_USER_PERMISSIONS_SELECT_ALL = 'SET_USER_PERMISSIONS_SELECT_ALL';
export const SET_USER_ID = 'SET_USER_ID';
